exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".contenedorTotal{padding:0;background-color:#f8f8ff}.cards2{box-shadow:1px 5px 7px 5px rgba(0,0,0,.1);margin-top:15px;border-left-width:0;padding:39px 50px 30px 55px;border-bottom-width:30px;border-color:15px gray}.contenedor{padding:0 2% 0 4%;background-color:#f8f8ff}.cards{box-shadow:1px 5px 7px 5px rgba(0,0,0,.1);border-left-width:px;padding:30px 50px 30px 55px;border-bottom-width:30px;border-color:15px gray}.car{border:1px solid transparent;border-color:#c4c4c4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06e524ee","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/componentes/filtrado.vue
// module id = 437
// module chunks = 0